import { preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { ButtonToolbar, Form } from "react-bootstrap";
import type EditableDetailViewModel from "../../viewModels/editableDetailViewModel";
import type { IEditableViewModel } from "../../viewModels/types";

export interface EditableDetailViewProps<TEntity> {
  vm: EditableDetailViewModel<TEntity> | IEditableViewModel<TEntity>;
  form: React.ReactElement;
  hideTitle?: boolean;
  titleClassName?: string;
}

function EditableDetailView<TEntity>(props: EditableDetailViewProps<TEntity>) {
  const { vm, form, hideTitle, titleClassName } = props;

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      {!hideTitle && <h3 className={titleClassName ?? "text-center"}>{vm.translate(vm.isEditable ? "edit" : "detail")}</h3>}
      <Form onSubmit={preventDefault(vm.save)}>
        {form}
        <ButtonToolbar className="justify-content-center">
          <Button size="sm" onClick={vm.cancel} type="reset" variant="light">
            {vm.translateGeneral("cancel")}
          </Button>
          {vm.isEditable && (
            <Button size="sm" type="submit" disabled={vm.busyWatcher.isBusy}>
              {vm.translateGeneral("save")}
            </Button>
          )}
        </ButtonToolbar>
      </Form>
    </LoaderOverlay>
  );
}

export default observer(EditableDetailView);
